<template>
  <div>
    <slot
      :hotel-images="hotelImages"
      :loading="hotelFetchState === fetchState.pending"
      :gid="gid"
      :fallback-images="fallbackImages"
    />
  </div>
</template>

<script>
import { mapActions, mapState } from 'pinia'
import hotelImagesMixin, { supplierURLs } from '@packages/media/mixins/hotel-images.mixin'
import charterHotelMixin from '@layers/web/mixins/charter-hotel.mixin'

const fetchState = {
  idle: 'idle',
  pending: 'pending',
  success: 'success',
  error: 'error',
}

export default defineNuxtComponent({
  name: 'HotelImageProvider',
  mixins: [charterHotelMixin, hotelImagesMixin],

  props: {
    giataId: {
      type: Number,
      required: true,
    },

    package: {
      type: Object,
      default: null,
    },

    staticImages: {
      type: Boolean,
      default: false,
    },
  },

  data () {
    return {
      hotel: null,
      hotelFetchState: fetchState.idle,
      fetchState,
    }
  },

  computed: {
    ...mapState(useLocaleStore, ['locale']),
    ...mapState(useHotelsStore, ['hotels', 'getHotelByGiataId']),
    hotelImages () {
      return this.images
    },

    gid () {
      return this.giataId || this.package?.giata_id
    },

    fallbackImages () {
      if (!this.staticImages && (!this.package || this.hotelFetchState !== fetchState.idle || this.hotelFetchState !== fetchState.pending)) {
        return []
      }
      const supplierURL = supplierURLs[this.package.image_type || this.package.supplier]
      const { image_1: image1, image_2: image2, image_3: image3 } = this.package

      return [
        ...new Set(
          [image1, image2, image3]
            .filter(Boolean)
            .map(path => supplierURL ? supplierURL.replace('[PATH]', path) : path)
        ),
      ]
    },
  },

  created () {
    if (!this.staticImages) {
      const hotel = this.getHotelByGiataId(this.gid)
      if (hotel) {
        this.hotel = hotel
      } else {
        this.fetchHotel()
      }
    }
  },

  methods: {
    ...mapActions(useHotelsStore, ['fetchSingle']),
    async fetchHotel () {
      if (this.gid) {
        this.hotelFetchState = fetchState.pending
        this.hotel = await this.fetchSingle(this.gid)

        if (this.hotel) {
          this.hotelFetchState = fetchState.success
        } else {
          this.hotelFetchState = fetchState.error
        }
      }
    },
  },
})
</script>
